import { call, put, takeLatest } from 'redux-saga/effects';
import { types, actions } from '../modules/SingleKeywords';
import { SingleKeywordsAPIs } from 'api';

const { SingleKeywordsAPI } = SingleKeywordsAPIs;

function* searchFlow(action) {
	try {
		const response = yield call(SingleKeywordsAPI, action.keyword);
		const responseData = response.data;

		if (responseData.status === 'OK') {
			yield put(actions.searchSuccess(responseData.data));
		} else {
			yield put(actions.searchFailed(responseData.error));
		}
	} catch (error) {
		yield put(actions.searchFailed(error));
	}
}

function* watchSearchRequest() {
	yield takeLatest(types.SEARCH_REQUEST, searchFlow);
}

export default [watchSearchRequest()];
